import { Box, InputAdornment, Typography } from "@mui/material";
import { ITkInputWithTextProps } from "../../../type/componentsType/TkInputWithText";
import TkLabelText from "../../atoms/TkLabelText";
import "./_style.scss";

/**
 * TkInputWithTexは、テキストと入力フィールドを含む部品です。
 *
 * @param {ITkInputWithTextProps} props - TkInputWithTextコンポーネントのプロパティ
 * @param innerText 入力フィールドのテキスト
 * @param outerTextLeft 入力フィールドの左側に表示されるテキスト
 * @param outerTextRight 入力フィールドの右側に表示されるテキスト
 * @param rest その他のTkLabelTextプロパティ
 */
const TkInputWithText: React.FC<ITkInputWithTextProps> = (props) => {
  const {
    innerText,
    outerTextLeft,
    outerTextRight,
    onlyNumber,
    onGetInputValue,
    ...rest
  } = props;
  return (
    <Box className="tkInputWithText">
      {outerTextLeft && (
        <Typography className="outerText">{outerTextLeft}</Typography>
      )}
      <TkLabelText
        onGetInputValue={onGetInputValue}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">{innerText}</InputAdornment>
          ),
          ...rest.InputProps,
        }}
        onlyNumber={onlyNumber}
        {...rest}
        className="tkInputWithTextInput"
      />
      {outerTextRight && (
        <Typography className="outerText">{outerTextRight}</Typography>
      )}
    </Box>
  );
};

export default TkInputWithText;
